/*
  JK Academy Logo System — uses the official brand asset.
  - Three variants: <LogoFull/>, <LogoIcon/>, <LogoWordmark/>
  - The source PNG contains both the shield and the "JK ACADEMY" wordmark.
    We use CSS object-position to crop to the shield for the icon variant.
*/

export const JK_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_prompt-mastery-58/artifacts/08uyyw04_1000013093.png";

/* -------------------------------------------------------------------------- */
/*  Icon (shield only) — cropped from the full logo                           */
/* -------------------------------------------------------------------------- */
export function LogoIcon({
  size = 40,
  className = "",
  glow = false,
  "data-testid": testId = "logo-icon",
}) {
  // The shield sits in the top-center of the source image (text "JK ACADEMY"
  // is below the shield). We zoom in on the shield using background-image.
  return (
    <div
      className={`relative inline-block ${className}`}
      style={{ width: size, height: size }}
      data-testid={testId}
    >
      {glow && (
        <div
          aria-hidden="true"
          className="absolute inset-0 rounded-full bg-cyan-400/35 blur-2xl scale-110"
        />
      )}
      <div
        aria-label="JK Academy"
        role="img"
        className="relative w-full h-full"
        style={{
          backgroundImage: `url(${JK_LOGO_URL})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "220% auto",
          backgroundPosition: "50% 22%",
        }}
      />
    </div>
  );
}

/* -------------------------------------------------------------------------- */
/*  Wordmark: "JK Academy" text — used at small sizes for clarity             */
/* -------------------------------------------------------------------------- */
export function LogoWordmark({
  className = "",
  size = "md", // sm | md | lg
  "data-testid": testId = "logo-wordmark",
}) {
  const sizeMap = {
    sm: "text-base",
    md: "text-lg",
    lg: "text-2xl sm:text-3xl",
  };
  return (
    <span
      className={`font-heading font-bold text-white tracking-tight ${sizeMap[size]} ${className}`}
      data-testid={testId}
    >
      JK Academy<span className="text-cyan-400">.</span>
    </span>
  );
}

/* -------------------------------------------------------------------------- */
/*  Full lockup — uses the real brand PNG (shield + wordmark baked in)        */
/* -------------------------------------------------------------------------- */
export function LogoFull({
  className = "",
  maxWidth = 420,
  glow = true,
  "data-testid": testId = "logo-full",
}) {
  return (
    <div
      className={`relative inline-block ${className}`}
      style={{ maxWidth }}
      data-testid={testId}
    >
      {glow && (
        <div
          aria-hidden="true"
          className="absolute inset-0 bg-cyan-400/25 blur-3xl scale-110 rounded-full"
        />
      )}
      <img
        src={JK_LOGO_URL}
        alt="JK Academy — AI Prompting Mastery"
        draggable={false}
        className="relative w-full h-auto select-none drop-shadow-[0_0_40px_rgba(34,211,238,0.25)]"
      />
    </div>
  );
}

export default LogoFull;
